import Decimal from 'decimal.js';

import { PaymentOptionDto } from './PaymentOptionDto';
import { PaymentPlanPromotionDto } from './PaymentPlanPromotionDto';

export class PaymentPlanDto {
    readonly weeklyPrice: Decimal;

    readonly discountApplied: Decimal;

    readonly contractLengthRatio: Decimal;

    readonly paymentPlanPremiumRatio: Decimal;

    readonly paymentOptions: PaymentOptionDto[];

    readonly promotion: PaymentPlanPromotionDto | null;

    readonly totalRent: Decimal;

    readonly subtotal: Decimal;

    readonly genericPrice: Decimal;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawPaymentPlan: any) {
        this.weeklyPrice = new Decimal(rawPaymentPlan.weeklyPrice);
        this.discountApplied = new Decimal(rawPaymentPlan.discountApplied);
        this.contractLengthRatio = new Decimal(rawPaymentPlan.contractLengthRatio);
        this.paymentPlanPremiumRatio = new Decimal(rawPaymentPlan.paymentPlanPremiumRatio);

        const paymentPlan = rawPaymentPlan.paymentOptions;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.paymentOptions = paymentPlan.map((option: any) => new PaymentOptionDto(option));
        this.promotion = rawPaymentPlan.promotion
            ? new PaymentPlanPromotionDto(rawPaymentPlan.promotion)
            : null;

        this.totalRent = new Decimal(rawPaymentPlan.totalRent);
        this.subtotal = new Decimal(rawPaymentPlan.subtotal);
        this.genericPrice = new Decimal(rawPaymentPlan.genericPrice);
    }
}
